import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Receipt from '@material-ui/icons/Receipt'
import { withStyles } from '@material-ui/core/styles'

import { COLORS } from 'Constants/Theme'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    padding: 5,
    fontSize: 20,
    borderRadius: '50px',
    color: COLORS.PRIMARY,
    backgroundColor: 'rgba(0, 122, 250, 0.15)',
  },
}

const ReceiptIcon = ({ classes, customClasses }) => (
  <div className={classnames(classes.container, customClasses.container)}>
    <Receipt className={classnames(classes.icon, customClasses.icon)} />
  </div>
)

ReceiptIcon.defaultProps = {
  customClasses: {},
}

ReceiptIcon.propTypes = {
  customClasses: PropTypes.object,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ReceiptIcon)
